<template>
  <div class="settings-panel__container">
    <div class="setting-section">
      <p class="setting-section__h">Позиция</p>
      <div class="setting-row">
        <label>Тип</label>
        <p><u>Иконка</u></p>
      </div>
      <div class="setting-row">
        <label>ID</label>
        <p class="setting-row__p"><u>{{ internalValue.id }}</u></p>
        <button @click="copyId(internalValue.id)" class="modal-copy__button">
          <Icon
            svgClass="modal-copy__svg"
            name="copy"
            size="16"
          />
        </button>
      </div>
      <div class="setting-row">
        <button @click="deleteElement()" class="modal-delete__button">
          <Icon
            svgClass="modal-copy__svg"
            name="close"
            size="16"
          />
          Удалить
        </button>
      </div>
    </div>
    <div class="setting-section" v-if="internalValue">
      <p class="setting-section__h">Иконка</p>
      <div class="setting-row">
        <label>Выбрать: </label>
        <IconPicker v-model="currentIcon" style="color:black" />
      </div>
      <div class="setting-row" v-if="iconChild">
        <label>Цвет</label>
        <ColorPicker
          :model-value="iconChild.settings?.color"
          @update:model-value="updateIconColor"
        />
      </div>
    </div>
  </div>
</template>

<script>
import IconPicker from "@/components/UI/Select/IconPicker.vue";
import { safeClone } from '@/utils/clone.js';
import {
  idGenerator,
} from '@/utils/blocks/block-settings-utils.js';

export default {
  name: "ButtonSettings",
  components: {  IconPicker },
  props: {
    internalValue: { type: Object, required: true }
  },
  emits: ['update:internal-value'],
  data() {
    return {
      currentIcon: '',
    };
  },
  computed: {
    iconChild() {
      return this.internalValue?.children?.data?.find(c => c.classes?.includes('icon')) || null;
    },
  },
  mounted () {
    if(this.internalValue) {
      this.currentIcon = this.internalValue.classes[1]
    }
  },
  watch: {
    currentIcon(newVal) {
      if (newVal) this.addOrReplaceIconChild(newVal);
    },
  },
  methods: {
    async deleteElement () {
      const id = this.internalValue?.id;
      if (!id) return;

      const ok = window.confirm('Удалить элемент и все его дочерние элементы?');
      if (!ok) return;

      try {
        await this.$store.dispatch('landing/DELETE_ELEMENT', id);
        try { this.$store.dispatch('activeElement/UPDATE_ACTIVE_ELEMENT', null); } catch(e){}
        try { this.$store.dispatch('choosedElement/UPDATE_CHOOSED_ELEMENT', null); } catch(e){}
        this.$emit('update:internal-value', null);
        // this.$emit('element-updated', null);
      } catch (err) {
        console.error('deleteElement failed', err);
      }
    },
    emitUpdated(newObj) {
      this.$emit('update:internal-value', safeClone(newObj));
    },
    addOrReplaceIconChild(iconClass) {
      const newVal = safeClone(this.internalValue || {});
      newVal.classes[1] = iconClass
      this.emitUpdated(newVal);
    },
    copyId (text) {
      if (!text) return Promise.resolve();
      if (navigator.clipboard && window.isSecureContext) return navigator.clipboard.writeText(text);
      const ta = document.createElement('textarea');
      ta.value = text;
      ta.style.position = 'fixed';
      ta.style.left = '-9999px';
      document.body.appendChild(ta);
      ta.focus();
      ta.select();
      try {
        document.execCommand('copy');
      } catch (e) {
      }
      document.body.removeChild(ta);
      return Promise.resolve();
    },
  }
};
</script>


<style scoped>
.setting-section { padding-bottom:0.5rem; margin-top:0.5rem; border-bottom:0.1rem solid var(--grey-0); display:flex; flex-direction:column; gap:0.5rem; }
.setting-row { display:flex; align-items:center; gap:0.5rem; }
.setting-column { display:flex; flex-direction:column; gap:0.5rem; width: 100%; }
.setting-section__h { text-align:start; font-weight:bold; }
.setting-delete__children { width: fit-content; }
.modal-choosed__container {
  width: 27rem;
  overflow: hidden;
  border-radius: 0.2rem;
}
.modal-choosed__element {
  overflow: scroll;
  height: 100%;
  width: 100%;
  text-wrap: nowrap;
}
.modal-header__h2 {
  font-size: 1.5rem;
  text-align: left;
}
.modal-footer__p {
  text-align: left;
}
.label-row {
  text-wrap: nowrap;
}
.setting-row__p {
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.modal-copy__svg {
  width: 1rem;
  height: 1rem;
}
.modal-copy__button {
  padding: 0;
  color: white;
  background-color: transparent;
  border: 0.1rem solid var(--color-0);
  padding: 0.2rem;
}
::v-deep(.setting-row > .multiselect__main > .multiselect > .multiselect__tags) {
  width: auto !important;
  text-wrap: nowrap !important;
  .multiselect__single {
    color: white;
    font-weight: 100;
  }
}
.modal-delete__button {
  padding: 0;
  color: white;
  background-color: transparent;
  border: 0.1rem solid var(--color-0);
  padding: 0.2rem;
}
</style>
